import React from "react";
import { Helmet } from "react-helmet-async";
import useFullUrl from "web/core/shop/useFullUrl";

const CmsPageSeo = (props) => {
  const fullUrl = useFullUrl(props.page.path);
  return (
    <Helmet>
      <title>{props.page.meta_title || props.page.title}</title>
      {props.page.meta_keywords && (
        <meta name="keywords" content={props.page.meta_keywords} />
      )}
      {props.page.meta_description && (
        <meta name="description" content={props.page.meta_description} />
      )}
      <meta
        name="google-site-verification"
        content="OKJxfdOVe5RixxVB0756_n4q9p-ailp5eyCiVgQerks"
      />
      {props.page.path && <link rel="canonical" href={fullUrl} />}
    </Helmet>
  );
};

export default CmsPageSeo;
